// #region imports

// --- Angular
import { OnInit, Input, EventEmitter, Output, HostListener, ElementRef } from '@angular/core';

// --- HS Code
import { User } from 'oidc-client';
import { LanguageModel } from '../../models';

// #endregion

export class NavBarBaseComponent implements OnInit {
  @Input() isLoading: boolean;
  @Input() identity: User;
  @Input() languages: LanguageModel[];
  @Input() selectedLanguage: LanguageModel;

  @Output() login = new EventEmitter();
  @Output() logout = new EventEmitter();
  @Output() languageChanged = new EventEmitter<LanguageModel>();

  constructor(private elementRef: ElementRef) { }

  ngOnInit() { }

  onLogin(): void {
    if (this.isLoading) {
      return;
    }

    this.login.emit();
  }

  signoutRedirect() {
    if (this.isLoading) {
      return;
    }

    this.logout.emit();
  }

  checkActive(e: any): void {
    if (this.isLoading) {
      e.preventDefault();
    }
  }

  onLanguageChanged(newLanguage: LanguageModel): void {
    this.languageChanged.emit(newLanguage);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: Event) {
     if (window.pageYOffset > 1) {
       this.elementRef.nativeElement.classList.add('sticky');
       if (this.elementRef.nativeElement &&
            this.elementRef.nativeElement.parentElement &&
            this.elementRef.nativeElement.parentElement.nextElementSibling) {
       const container = this.elementRef.nativeElement.parentElement.nextElementSibling.querySelector('.questions-container');
       if (container) {
         container.classList.add('gooey');
       }
      }
     } else {
      this.elementRef.nativeElement.classList.remove('sticky');
      if (this.elementRef.nativeElement &&
        this.elementRef.nativeElement.parentElement &&
        this.elementRef.nativeElement.parentElement.nextElementSibling) {
          const container = this.elementRef.nativeElement.parentElement.nextElementSibling.querySelector('.questions-container');
          if (container) {
            container.classList.remove('gooey');
          }
      }
    }
  }
}
